/**
 * GenreGroup entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class GenreGroup extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            page_id: null, // 1: Agenda, 2: Magazin, 3: Service, 4: Kulturplatz, 5: Freie Seiten
            slug: null,
            display_order: null,
            group_type: null,
            html_title: null,
            import_match: null,
            event_class: null,
            interface_value_ident: null,

            // view props:
            page_title: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            page_id: Number,
            display_order: Number,
        };
    }

    entityName() {
        return 'GenreGroup';
    }
}

export class GenreGroupCollection extends BaseCollection {
    options() {
        return {
            model: GenreGroup,
        };
    }

    entityName() {
        return 'GenreGroup';
    }
}
